import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiRespuesta } from '@app/models/ApiRespuesta.interface';

export type AreaAyuda = 'sistema' | 'gv' | 'tarjetas' | 'checklists' | 'medio-ambiente' | 'rrhh';

export interface ContactoAcceso {
    id: string;
    nombre: string;
    correo: string | null;
}

export interface GrupoAyudaAcceso {
    id: AreaAyuda;
    nombre: string;
    contactos: ContactoAcceso[];
}

export const AREAS_AYUDA: { id: AreaAyuda; nombre: string; icono: string }[] = [
    { id: 'sistema', nombre: 'Mi cuenta y permisos', icono: 'pi pi-users' },
    { id: 'gv', nombre: 'Gerenciamientos (GV)', icono: 'pi pi-car' },
    { id: 'tarjetas', nombre: 'Tarjetas de observación', icono: 'pi pi-eye' },
    { id: 'checklists', nombre: 'Checklists HSE', icono: 'pi pi-check-square' },
    { id: 'medio-ambiente', nombre: 'Medio Ambiente', icono: 'pi pi-sun' },
    { id: 'rrhh', nombre: 'RRHH', icono: 'pi pi-briefcase' },
];

export function esAreaAyuda(value: string | null): value is AreaAyuda {
    return AREAS_AYUDA.some((area) => area.id === value);
}

export function areaAyudaDeRuta(url: string): AreaAyuda {
    const path = url.split(/[?#]/, 1)[0].toLowerCase().split('/').filter(Boolean);
    if (path.includes('gestionvehicular')) return 'gv';
    if (path.includes('tarjetasobs')) return 'tarjetas';
    if (path.includes('listasverificacion') || path.includes('checklists')) {
        return path[0] === 'medio-ambiente' ? 'medio-ambiente' : 'checklists';
    }
    if (path[0] === 'medio-ambiente') return 'medio-ambiente';
    if (path[0] === 'rrhh') return 'rrhh';
    return 'sistema';
}

@Injectable({ providedIn: 'root' })
export class AyudaAccesosService {
    private readonly http = inject(HttpClient);

    getContactos() {
        return this.http.get<ApiRespuesta<GrupoAyudaAcceso[]>>(`${environment.url}usuario/ayuda-accesos`).pipe(map((response) => response.result));
    }
}
